module.exports = __webpack_public_path__ + "media/icon_transaction/frog_2-99cfd338.png";